// extracted by mini-css-extract-plugin
export default {"radio":"radio-avKyO","title":"title-MPnLh"};